<template>
  <div v-show="agentSetup.currentPage === 3" class="bg-base-100 border border-base-300 rounded-box p-6 shadow-sm" style="min-height: 40vh;">
    <div class="mb-6" id="tabTitle">
      <h1 class="text-2xl font-semibold tracking-tight text-base-content" :style="agentSetup.isRtl === true ? { direction: 'rtl', textAlign: 'right' } : { direction: 'ltr', textAlign: 'left' }">{{ agentSetup.t('aiChatAgentSetup.tabs.deploymentChannels', 'Deployment Channels') }}</h1>
    </div>

    <DeploymentChannelsInlineSelector
      v-model:selectedChannels="agentSetup.selectedDeploymentChannels"
      v-model:whatsappSourceId="agentSetup.selectedWhatsappSourceId"
      :agentId="agentSetup.route.query.edit"
      :whatsappNumber="agentSetup.whatsappDisplayNumber"
      v-model:phoneSourceId="agentSetup.selectedPhoneSourceId"
      :phoneNumber="agentSetup.phoneDisplayNumber"
      :enabledChannels="agentSetup.enabledDeploymentChannels"
    />

    <div class="flex justify-between mt-6" style="position: relative;">
      <button @click="agentSetup.goNextStep(3, -1)" class="btn">
        <span v-if="agentSetup.isNavigating === 2" class="loading loading-spinner loading-sm mr-2"></span>
        {{ agentSetup.t('aiChatAgentSetup.buttons.previousStep', 'Previous Step') }}
      </button>
      <div class="flex items-center space-x-2" :class="agentSetup.isRtl === true ? 'space-x-reverse' : ''">
        <button v-if="agentSetup.isEditMode === true && agentSetup.uploadedFiles.length === 0" @click="agentSetup.saveAgentWithoutRedirect" class="btn btn-neutral">
          <span v-if="agentSetup.isSaving === true && agentSetup.isSavingAndRedirecting === false" class="loading loading-spinner loading-sm mr-2"></span>
          {{ agentSetup.t('aiChatAgentSetup.buttons.save', 'Save') }}
        </button>
        <button v-if="agentSetup.isEditMode === true" @click="agentSetup.createAgent(true)" class="btn">
          <span v-if="agentSetup.isSaving === true && agentSetup.isSavingAndRedirecting === true" class="loading loading-spinner loading-sm mr-2"></span>
          {{ agentSetup.t('aiChatAgentSetup.buttons.saveAndClose', 'Save & Close') }}
        </button>
        <button @click="agentSetup.goNextStep(3, 1)" class="btn">
          <span v-if="agentSetup.isNavigating === 4" class="loading loading-spinner loading-sm mr-2"></span>
          {{ agentSetup.t('aiChatAgentSetup.buttons.nextStep', 'Next Step') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import DeploymentChannelsInlineSelector from '@/components/DeploymentChannelsInlineSelector.vue';
import { useAgentSetupContext } from '@/components/AgentSetupContext.js';

const agentSetup = useAgentSetupContext();
</script>
